import { getGameClientFrame } from '@/utilities/getters/getGameClientFrame';
import { buildClientURL } from '@/utilities/helpers/buildClientURL';

const reloadIframe = (forceIframeReload?: boolean) => {
  const frame = getGameClientFrame();

  if (!frame) return;

  if (frame.contentWindow && !forceIframeReload) {
    frame.contentWindow.postMessage({ type: 'GL/IOS_SOFT_RELOAD' }, frame.src);
  }

  if (forceIframeReload) {
    const gameClientUrl = buildClientURL();
    if (frame) {
      frame.setAttribute('src', gameClientUrl);
    }
  }
};

export default reloadIframe;
